import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";
import { Button, SaveButton } from "../../../../components/Buttons";

export const Product = () => {
    document.title = "Məhsul";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Kassa", value: "/cash" },
        { name: "Ayarlar", value: "/cash/settings" },
        { name: "Məhsul", value: "/cash/settings/product", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Məhsul</h2>
                    <p>
                        Kassa proqramında istifadəçiyə görünən məhsulun məlumatlarını tənzimləmək olar
                        <ol>
                            <li>
                                Kassa proqramında <Button>Ayarlar</Button> düyməsini sıxın, şifrəni daxil edib <Button>Enter</Button> düyməsi ilə ayarlara keçid
                                edin
                            </li>
                            <li>
                                Açılan pəncərədə <b>Məhsul</b> seçimini edin
                            </li>
                            <li>Birdən çox ölçü vahidi olan məhsul üçün nəzərdə tutulub. Səbətə əlavə olunan zaman əsas vahid və ya seçim ilə tənzimlənir</li>
                            <li>
                                Daha sonra, kassa proqramında görünəcək məhsulun <mark>minimal qiyməti</mark> seçimini edin və <SaveButton /> düyməsini sıxın
                            </li>
                        </ol>
                    </p>
                    <img src="/images/cash/settings/product-1.gif" alt="Məhsul" />
                    <h2>Partiyalı Məhsul</h2>
                    <p>Partiyalı məhsulun satışı zamanı partiya seçimi avtomatik olaraq verilir</p>
                    <img src="/images/cash/settings/product-2.gif" alt="Məhsul" />
                </article>
            </div>
        </div>
    );
};
